import IService from "./service";

export default class ConditionsService extends IService {
    
    process(conditions, fields) {
        conditions.forEach((condition) => {
            var fulfilling = false;

            if (condition.has_field_id) {
                let fulfilledField = fields.find(field => field.field_id === condition.has_field_id);

                if (fulfilledField) {
                    if (condition.field_option_id || condition.field_text_value) {
                        if (condition.field_option_id && Array.isArray(fulfilledField.value.value)) {
                            fulfilledField.value.value.forEach((valueVal) => {
                                if (valueVal === condition.field_option_id) {
                                    fulfilling = true;
                                }
                            });
                        } else if (condition.field_option_id && fulfilledField.value.value instanceof Object) {
                            Object.entries(fulfilledField.value.value).forEach(([, valueVal]) => {
                                if (valueVal === condition.field_option_id) {
                                    fulfilling = true;
                                }
                            });
                        } else if (condition.field_option_id && typeof fulfilledField.value.value === 'string' && fulfilledField.value.value === condition.field_option_id) {
                            fulfilling = true;
                        }

                        if (condition.field_text_value) {
                            if (fulfilledField.value.value === condition.field_text_value) {
                                fulfilling = true;
                            }
                        }
                    } else {
                        if (!fulfilledField.value.isEmpty) {
                            fulfilling = true;
                        }
                    }

                    if (condition.conditional_type === 'field') {
                        fields.some((field) => {
                            if (field.field_id === condition.conditional_id) {
                                if (fulfilling) {
                                    field['is_visible'] = !!condition.is_include;
                                } else {
                                    field['is_visible'] = !condition.is_include;
                                }
                                return true;
                            }
                            return false;
                        })
                    }

                    if (condition.conditional_type === 'option') {
                        fields.some((field) => {
                            if (field.options) {
                                field.options.forEach((option) => {
                                    if (option.id === condition.conditional_id) {
                                        if (fulfilling) {
                                            option['is_visible'] = !!condition.is_include;
                                        } else {
                                            option['is_visible'] = !condition.is_include;
                                        }
                                        return true;
                                    }
                                    return false;
                                })
                            }
                        })
                    }
                }
            }
        });

        return fields;
    }
}
